import type { PropsWithChildren } from "react";
import { ReactElement } from "react";
import { Box, Container, createStyles, makeStyles } from "@material-ui/core";

import { Theme } from "theme";

export const baseContainerMaxWidthStyles = {
  margin: "auto",
  maxWidth: "91.5rem",
  padding: "0 2rem 0 2rem",
  width: "100%",
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    contentContainer: {
      ...baseContainerMaxWidthStyles,
      display: "flex",
      flexDirection: "column",
      [theme.breakpoints.only("xs")]: {
        padding: "1rem",
        textAlign: "center",
      },
    },
  }),
);

type BaseContainerProps = {
  renderFullWidthContent?: () => ReactElement;
};

const BaseContainer = ({
  renderFullWidthContent,
  children,
}: PropsWithChildren<BaseContainerProps>) => {
  const classes = useStyles();
  return (
    <Container disableGutters maxWidth={false}>
      {renderFullWidthContent && renderFullWidthContent()}
      <Box className={classes.contentContainer}>{children}</Box>
    </Container>
  );
};

export default BaseContainer;
